module.exports = __webpack_public_path__ + "static/img/icon_ice.19793805.png";